import React from "react";

// Our Clients
import imgZhenHuaOil from "../assets/images/partners/1.jpg";
import imgBluetron from "../assets/images/partners/10.jpg";
import imgStateGrid from "../assets/images/partners/3.jpg";
import imgPetroChina from "../assets/images/partners/9.jpg";
import imgCPP from "../assets/images/partners/5.jpg";
import imgSinopec from "../assets/images/partners/6.jpg";
import imgHoteam from "../assets/images/partners/11.jpg";
import imgCUPB from "../assets/images/partners/12.jpg";

// Main Contractors
import imgKent from "../assets/images/partners/4.jpg";
import imgADNOC from "../assets/images/partners/2.jpg";
import imgAramco from "../assets/images/partners/7.jpg";
import imgTotal from "../assets/images/partners/8.jpg";

const PartnerSection = () => {
  const clients = [
    { name: "ZhenHuaOil", logo: imgZhenHuaOil },
    { name: "Bluetron", logo: imgBluetron },
    { name: "State Grid", logo: imgStateGrid },
    { name: "PetroChina", logo: imgPetroChina },
    { name: "CPP", logo: imgCPP },
    { name: "SINOPEC", logo: imgSinopec },
    { name: "Hoteam Software", logo: imgHoteam },
    { name: "China University of Petroleum Beijing", logo: imgCUPB },
  ];

  const contractors = [
    { name: "Kent", logo: imgKent },
    { name: "ADNOC", logo: imgADNOC },
    { name: "Saudi Aramco", logo: imgAramco },
    { name: "Total", logo: imgTotal },
  ];

  // 4 rows per column (column-based grid)
  const ColumnGrid = ({ items }) => (
    <div className="grid grid-rows-4 grid-flow-col gap-6 md:gap-8">
      {items.map((item, index) => (
        <div
          key={index}
          className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 flex items-center justify-center h-28 md:h-32 p-4"
        >
          <img
            src={item.logo}
            alt={item.name}
            className="max-h-16 object-contain grayscale hover:grayscale-0 transition duration-300"
          />
        </div>
      ))}
    </div>
  );

  return (
    <section className="bg-gradient-to-b from-[#f6f9ff] to-[#eaf3fb] py-16 px-6 md:px-12">
      
      {/* Two Columns Layout */}
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-20">

        {/* LEFT — Clients */}
        <div>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              <span className="text-orange-500">««</span> Our Clients{" "}
              <span className="text-orange-500">»»</span>
            </h2>
          </div>

          <ColumnGrid items={clients} />
        </div>

        {/* RIGHT — Contractors */}
        <div>
          <div className="text-center mb-12">
             <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              <span className="text-orange-500">««</span> Main Contractors{" "}
              <span className="text-orange-500">»»</span>
            </h2>
          </div>

          <ColumnGrid items={contractors} />
        </div>

      </div>
    </section>
  );
};

export default PartnerSection;
